var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOven = function SvgOven(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2a4d4f"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3993",
    d: "M21.722 0H1.278A1.278 1.278 0 0 0 0 1.278v20.444A1.278 1.278 0 0 0 1.278 23h20.444A1.278 1.278 0 0 0 23 21.722V1.278A1.278 1.278 0 0 0 21.722 0Zm0 21.722H1.278V1.278h20.444Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3994",
    d: "M6.389 3.833a1.278 1.278 0 1 1-2.556 0 1.278 1.278 0 1 1 2.556 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3995",
    d: "M12.778 3.833a1.278 1.278 0 1 1-2.556 0 1.278 1.278 0 1 1 2.556 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3996",
    d: "M19.167 3.833a1.278 1.278 0 1 1-2.556 0 1.278 1.278 0 1 1 2.556 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3997",
    d: "M20.445 6.389H2.556v14.056h17.889Zm-1.278 2.556H3.834V7.667h15.333Z"
  }))));
};
export default SvgOven;